var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_c('th',[_vm._v("Venc.")]),_c('th',[_vm._v("Cuota")]),_c('th',[_vm._v("Amortización")]),_c('th',[_vm._v("Interés")]),_c('th',[_vm._v("Seguros")]),_c('th',[_vm._v("Mora y"),_c('br'),_vm._v("Penalidad")]),_c('th',[_vm._v("Fecha Pago")]),_c('th',[_vm._v("Estado")])])])
}]

export { render, staticRenderFns }